import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { LoginGuard } from './shared/guards/login/login.guard';
import { RoleSwitchGuard } from './shared/guards/role-switch/role-switch-guard';

const routerDefinitions: Routes = [
  {
    path: AppRoutes.DATA_ENTRY_PAGE,
    loadChildren: () => import('./data-entry-page/data-entry-page.module').then((m) => m.DataEntryPageModule),
    canActivate: [XpoAuthenticationGuard],
  },
  {
    path: AppRoutes.LANDING_PAGE,
    component: LandingPageComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  // ADD ANY NEW ROUTE / PAGE HERE
  {
    path: '**',
    redirectTo: `/${AppRoutes.LANDING_PAGE}`,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routerDefinitions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
